// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCTIBB4n92354gmtWoyq4UDOQ0JrrMpi4A",
  authDomain: "inicio-mysocial.firebaseapp.com",
  projectId: "inicio-mysocial",
  storageBucket: "inicio-mysocial.appspot.com",
  messagingSenderId: "1079052592385",
  appId: "1:1079052592385:web:09690f306bf27390a42700"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });